import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../../lib/api";
import ArtifactPage from "./ArtifactPage";

export default function FinancePage() {
  const { projectId } = useParams();
  const [labour, setLabour] = useState(null);

  useEffect(() => {
    api.get(`/projects/${projectId}/labour-cost`).then((r) => setLabour(r.data)).catch(() => {});
  }, [projectId]);

  return (
    <div data-testid="finance-page">
      {labour && labour.totalHours > 0 && (
        <div data-testid="labour-cost-panel" className="border border-border bg-card p-4 mb-5">
          <div className="flex flex-wrap items-start gap-8">
            <div>
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Labour actuals (timesheets)</div>
              <div data-testid="labour-total-cost" className="font-display font-black text-3xl tracking-tighter text-[#1E6FE8]">${labour.totalCost.toLocaleString()}</div>
              <div className="text-xs text-muted-foreground">{labour.totalHours}h logged{labour.unratedHours > 0 && <span className="text-amber-600"> · {labour.unratedHours}h without a rate — set rates on <Link to={`/projects/${projectId}/workload`} className="underline">Resource Workload</Link></span>}</div>
            </div>
            <div className="flex-1 min-w-[280px]">
              <table className="w-full text-xs">
                <thead><tr className="text-left text-muted-foreground"><th className="pb-1">Member</th><th className="pb-1 text-right">Hours</th><th className="pb-1 text-right">Rate</th><th className="pb-1 text-right">Cost</th></tr></thead>
                <tbody>
                  {labour.byMember.map((m) => (
                    <tr key={m.userId} data-testid="labour-member-row" className="border-t border-border">
                      <td className="py-1">{m.name}</td>
                      <td className="py-1 text-right">{m.hours}h</td>
                      <td className="py-1 text-right">{m.rate ? `$${m.rate}/h` : <span className="text-amber-600">no rate</span>}</td>
                      <td className="py-1 text-right font-semibold">${m.cost.toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      <ArtifactPage type="finance_lines" />
    </div>
  );
}
